import * as utils from '../../../shared';
export function shortCommodities(fullName: string): string {
  return utils.shortCommodities(fullName);
} 